<div class="relative w-screen max-w-screen h-fit flex items-center justify-center z-[-999]">
	<img
		src="/assets/images/separator_team_peps.avif"
		alt="Séparateur Team Peps"
		class="object-cover object-center absolute h-[12vh] xs:h-[18vh] sm:h-[30vh] md:h-[40vh] lg:h-[45vh] xl:h-[50vh] 2xl:h-[60vh] "
	/>
</div>
